import * as React from "react";
const IconSquareMedical = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M58 2H6C3.8 2 2 3.8 2 6v52c0 2.2 1.8 4 4 4h52c2.2 0 4-1.8 4-4V6c0-2.2-1.8-4-4-4m2 56c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2h52c1.1 0 2 .9 2 2z" />
    <path d="M42.1 31H33v-9.1c0-.6-.4-1-1-1s-1 .4-1 1V31h-9.1c-.6 0-1 .4-1 1s.4 1 1 1H31v9.1c0 .6.4 1 1 1s1-.4 1-1V33h9.1c.6 0 1-.4 1-1s-.4-1-1-1" />
  </svg>
);
export default IconSquareMedical;
